import setInfoCardData from './set-info-card-data';

export {setInfoCardData};